<template>
  <div class="az-choco-icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="116"
      height="108"
      viewBox="0 0 116 108"
      fill="none"
    >
      <g filter="url(#filter0_d_56_140)">
        <path
          d="M60.5926 9.36627C60.893 9.03589 61.4043 9.01155 61.7347 9.31191L71.852 18.5099L58.5678 33.122L47.8522 23.3802L60.5926 9.36627Z"
          fill="#562800"
          stroke="#704118"
          stroke-width="3.23385"
        />
        <path
          d="M71.8525 18.5093L82.5681 28.2511L69.2838 42.8632L58.5683 33.1214L71.8525 18.5093Z"
          fill="#562800"
          stroke="#704118"
          stroke-width="3.23385"
        />
        <path
          d="M103.203 30.9966L107.366 44.0209C107.501 44.4462 107.267 44.9012 106.842 45.0371L88.8011 50.8034L84.3921 37.0089L103.203 30.9966Z"
          fill="#562800"
          stroke="#704118"
          stroke-width="3.23385"
        />
        <path
          d="M34.5686 37.9917L45.2842 47.7335L31.9999 62.3456L21.2843 52.6038L34.5686 37.9917Z"
          fill="#562800"
          stroke="#704118"
          stroke-width="3.23385"
        />
        <path
          d="M45.2839 47.7334L55.9995 57.4752L42.7152 72.0873L31.9997 62.3455L45.2839 47.7334Z"
          fill="#562800"
          stroke="#704118"
          stroke-width="3.23385"
        />
        <path
          d="M56 57.4751L66.7156 67.2169L53.4313 81.829L42.7157 72.0872L56 57.4751Z"
          fill="#562800"
          stroke="#704118"
          stroke-width="3.23385"
        />
        <path
          d="M47.8525 23.3794L58.5681 33.1212L45.2838 47.7333L34.5683 37.9915L47.8525 23.3794Z"
          fill="#562800"
          stroke="#704118"
          stroke-width="3.23385"
        />
        <path
          d="M58.5686 33.1216L69.2842 42.8634L55.9999 57.4755L45.2843 47.7337L58.5686 33.1216Z"
          fill="#562800"
          stroke="#704118"
          stroke-width="3.23385"
        />
        <path
          d="M69.2839 42.8633L79.9995 52.6051L66.7152 67.2172L55.9997 57.4754L69.2839 42.8633Z"
          fill="#562800"
          stroke="#704118"
          stroke-width="3.23385"
        />
        <path
          d="M21.2847 52.604L32.0002 62.3458L18.716 76.9579L8.5986 67.76C8.26822 67.4596 8.24389 66.9483 8.54424 66.6179L21.2847 52.604Z"
          fill="#562800"
          stroke="#704118"
          stroke-width="3.23385"
        />
        <path
          d="M32 62.3452L42.7156 72.087L29.4313 86.6991L18.7157 76.9573L32 62.3452Z"
          fill="#562800"
          stroke="#704118"
          stroke-width="3.23385"
        />
        <path
          d="M42.7153 72.0869L53.4309 81.8287L40.6905 95.8426C40.3901 96.173 39.8788 96.1974 39.5484 95.897L29.4311 86.699L42.7153 72.0869Z"
          fill="#562800"
          stroke="#704118"
          stroke-width="3.23385"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_56_140"
          x="0.166502"
          y="4.20959"
          width="115.406"
          height="103.34"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.27527" />
          <feGaussianBlur stdDeviation="3.27527" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_56_140"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_56_140"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  </div>
</template>
